<template>
  <div style="display: contents;">
    <ValidationObserver ref="bookingForm" slim>
      <b-form name="BookingPaxFrm" novalidate @submit.prevent="book()">
        <b-row>
          <b-container class="content">
            <div class="printArea">
              <b-row>
                <SearchParamsSummary :params="params" />
              </b-row>
              <HotelInfo :info="result.hotelInfo" />
            </div>
            <b-row>
              <b-col sm="12" class="printArea">
                <b-table-simple stacked="sm" striped caption-top  class="table table-sm border">
                  <caption class="pl-2 pl-sm-0 pb-0"><h6 class="package-title">Detalii Camere si Pasageri</h6></caption>
                  <b-thead class="t-head hh-t-head">
                    <b-tr>
                      <b-td>Camera</b-td>
                      <b-td></b-td>
                      <b-td>Nume*</b-td>
                      <b-td>Prenume*</b-td>
                      <b-td>Varsta</b-td>
                      <b-td>Data nasterii*</b-td>
                    </b-tr>
                  </b-thead>
                  <b-tbody v-for="(room,rIndex) in pax" :key="rIndex">
                    <template v-for="(p, pIndex) in room">
                      <PaxForm
                        class="noPrint"
                        v-model="room[pIndex]"
                        :room="rIndex + 1"
                        :id="'room' + rIndex + 'pax' + pIndex"
                        :key="'pax' + pIndex"
                        :travelDate="travelDate"
                      />
                       <div :key="pIndex" style="display: none">
                        <tr>
                          <td>{{ rIndex + 1 }}</td>
                          <td>{{ room[pIndex].title }}</td>
                          <td>{{ room[pIndex].lname }}</td>
                          <td>{{ room[pIndex].fname }}</td>
                          <td>{{ room[pIndex].age }}</td>
                          <td>{{ room[pIndex].bdate }}</td>
                        </tr>
                      </div>
                    </template>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <InvoicingForm v-model="client" v-if="userData.is_mandated === 't'"/>
            <b-row class="my-3">
              <b-col sm="6">
                <div class="printArea">
                  <h6>Note Agent*</h6>
                  <textarea v-model="notes" class="form-control noPrint">...</textarea>
                  <div class="printArea" style="display: none">
                    <p>{{ notes }}</p>
                  </div>
                </div>
              </b-col>
              <b-col sm="6">
                <span class="printArea">
                  <h6>Numar de telefon*</h6>
                  <span class="printArea" style="display: none">{{client.tel}}</span>
                </span>
                <ValidationProvider
                  name="numar de telefon"
                  :rules="{ required: true }"
                  v-slot="vContext"
                  >
                  <b-form-group>
                    <b-form-input
                      type="text"
                      :name="'telefon'"
                      placeholder="nr de telefon"
                      class="form-control form-control-sm"
                      v-model="client.tel"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="telefon"
                    ></b-form-input>
                    <b-form-invalid-feedback id="telefon">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <small>*Acest numar de telefon va fi utilizat exclusiv pentru contactarea turistilor in caz de urgenta.</small>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="7">
                <b-card>
                  <ValidationProvider
                    name="termeni si conditii"
                    rules="is:acceptat"
                    vid="terms"
                    v-slot="vContext"
                    slim
                  >
                    <b-form-group class="mb-0">
                      <b-form-checkbox
                        id="conditions"
                        name="conditions"
                        v-model="termsAccepted"
                        :state="getValidationState(vContext)"
                        aria-describedby="conditions-live-feedback"
                        value="acceptat"
                        unchecked-value="neacceptat"
                        >
                          Am citit si sunt de acord cu <span class="text-info"  @click="openTermsAndConditions">Termenii si conditiile</span> de comercializare a produselor.
                        </b-form-checkbox>
                      <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)">nu ati acceptat termenii si conditiile</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-card>
              </b-col>
              <b-col md="5" class="printArea">
                <b-card
                  bg-variant="light"
                  style="font-size:16px;"
                  class="text-center"
                >
                  <b-form-group class="mb-0">
                    <span>Pret total: <span class="text-danger font-weight-bold">{{ price }} {{params.currency}} </span> <small>(taxe incluse)</small></span>
                  </b-form-group>
                   <div class="text-center">
                      <small v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
                        {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || 'diferenta' }}</b>
                      </small>
                    </div>
                </b-card>
              </b-col>
            </b-row>
            <b-row  class="my-3">
              <b-col>
                <b-card
                  bg-variant="light"
                  no-body
                >
                  <b-card-body class="p-1 p-md-3">
                    <div class="d-md-flex justify-content-md-between">
                      <b-button variant="warning" size="sm" @click="back" class="mb-2 mb-md-0"><b-icon icon="chevron-left" />Inapoi la rezultate</b-button>
                      <b-button-group size="sm">
                          <button class="btn btn-outline-primary btn-sm " @click.prevent="onPrint" v-b-tooltip.hover title="Print">
                            <b-icon icon="window" /> Tipareste detalii
                          </button>
                          <button class="btn btn-outline-danger btn-sm" @click.prevent="onDownload" v-b-tooltip.hover title="PDF">
                            <b-icon icon="download" /> Detalii PDF
                          </button>
                          <b-button
                            v-if="category.allowOption"
                            variant="primary custom-primary"
                            @click.prevent="book(true)"
                            v-b-popover.hover.top="'ATENTIE: Aceasta rezervare este valabila 48h si nu este garantata – se blocheaza locurile la transport, dar nu se garanteaza disponibilitatea hotelului, care poate intra in Stop Sales.'"
                            title="Rezervare in Option">Rezervare in Option</b-button>
                          <b-button variant="warning" type="submit">Rezerva acum</b-button>
                        </b-button-group>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-form>
    </ValidationObserver>
    <b-modal v-model="showOverlay" title="Status" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <b-aspect class="align-items-center text-center" aspect="3">
          <b-spinner label="Loading..." variant="primary"></b-spinner>
          <b-card-text>{{ overlayMessage }}</b-card-text>
        </b-aspect>
      </b-card>
    </b-modal>
    <b-modal v-model="showErrorOverlay" title="Error" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card class="justify-content-center">
        <b-aspect aspect="3" class="align-items-center">
          <b-card-title class=" font-weight-bold text-center">
            <b-icon icon="exclamation-triangle" class="text-danger mr-3"/>
            A aparut o problema
          </b-card-title>
          <hr>
          <b-card-text class="lead text-muted"> - Din pacate rezervarea nu a putut fi inregistrata deoarece a aparut o problema.</b-card-text>
          <b-card-text class="lead text-muted"> - In general acest lucru se intampla atunci cand pretul sau disponibilitatea produsului s-au modificat de la momentul in care ati efectuat cautarea.</b-card-text>
          <b-card-text class="lead text-muted"> Mesajul de eroare este: <b class="text-info">{{ errorMessage }}</b></b-card-text>
        </b-aspect>
        <hr>
        <b-button variant="warning float-right" size="sm" @click="back">Inapoi la rezultate</b-button>
      </b-card>
    </b-modal>
    <b-modal v-model="termsAndConditions" title="Termeni si Conditii" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <TermsAndConditions/>
        <hr>
        <b-button variant="warning" class="float-right"  @click="closeTermsAndConditions">Accepta</b-button>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

import model from '../services/model'
import toast from 'b2b-common/mixins/toast'
import auth from '@/app/private/shared/mixins/auth'
import validation from 'b2b-common/mixins/validation'
import SearchParamsSummary from './search_params_summary'
import HotelInfo from '@/app/private/shared/components/hotel_info'
import PaxForm from '@/app/private/shared/components/pax_form'
import InvoicingForm from '@/app/private/shared/components/invoicing_info_form'
import TermsAndConditions from '../../shared/components/terms_and_conditions'

import { search, book, paymentSchedule } from 'b2b-common/services/api/hotel'
import { getCustomPdf, downloadPdf, openPrintPage } from 'b2b-common/services/api/document'

const calculatePrice = (category, meal) => {
  const p = meal.price + meal.tax
  return p
}

const invalidFormMessage = 'Formular invalid'

export default {
  mixins: [toast, auth, validation],
  props: ['params', 'result', 'pack', 'category', 'meal'],
  components: { HotelInfo, SearchParamsSummary, InvoicingForm, PaxForm, TermsAndConditions },
  computed: {
    price () {
      return calculatePrice(this.category, this.meal, this.selectedExtras)
    }
  },
  data () {
    const travelDate = moment(this.params.checkIn, 'DD-MM-YYYY')

    const rooms = []
    let noAdults = 0
    let noChildren = 0
    this.params.rooms.forEach(room => {
      const pax = []
      noAdults += room.adults
      noChildren += room.ages.length
      for (let i = 0; i < room.adults; i++) {
        pax.push({
          title: 'Mr',
          fname: '',
          lname: '',
          age: 'adult',
          bdate: null
        })
      }
      room.ages.forEach(age => {
        pax.push({
          title: (age < 2) ? 'Inf' : 'Chd',
          fname: '',
          lname: '',
          age: age,
          bdate: null
        })
      })
      rooms.push(pax)
    })

    return {
      travelDate,
      noAdults,
      noChildren,
      notes: '',
      telephone: '',
      pax: rooms,
      paymentSchedule: [],
      termsAccepted: 'neacceptat',
      client: {
        clientCode: '',
        isCompany: false,
        companyName: '',
        companyNo: '',
        vatNo: '',
        bankAccount: '',
        bankName: '',
        title: 'Mr',
        firstName: '',
        lastName: '',
        idInfo: '',
        cnp: '',
        address1: '',
        address2: '',
        county: '',
        city: '',
        tel: '',
        email: ''
      },
      showErrorOverlay: false,
      showOverlay: false,
      overlayMessage: '',
      errorMessage: 'unknown error',
      termsAndConditions: false
    }
  },
  async created () {
    this.paymentSchedule = await paymentSchedule({
      source: this.result.source,
      category: this.category.id,
      meal: this.meal.id
    })
  },
  methods: {
    onPrint () {
      this.$refs.bookingForm.validate()
        .then(success => {
          if (!success) {
            this.addToast({ title: invalidFormMessage, message: 'Va rugam completati toate campurile obligatorii!', variant: 'danger' })
            return
          }
          const arr = document.getElementsByClassName('printArea')
          let html = ''
          arr.forEach(el => {
            html += el.innerHTML
          })
          openPrintPage({ html })
        })
    },
    onDownload () {
      this.$refs.bookingForm.validate()
        .then(success => {
          if (!success) {
            this.addToast({ title: invalidFormMessage, message: 'Va rugam completati toate campurile obligatorii!', variant: 'danger' })
            return
          }
          const arr = document.getElementsByClassName('printArea')
          let html = ''
          arr.forEach(el => {
            html += el.innerHTML
          })
          getCustomPdf({ html })
            .then(pdfData => {
              downloadPdf({ pdfData, fileName: 'oferta.pdf', dataType: 'raw' })
            })
        })
    },
    back () {
      this.$emit('back')
    },
    openTermsAndConditions () {
      this.termsAndConditions = true
    },
    closeTermsAndConditions () {
      this.termsAndConditions = false
    },
    async book (isOption = false) {
      try {
        const success = await this.$refs.bookingForm.validate()
        if (!success) {
          this.addToast({ title: invalidFormMessage, message: 'Va rugam completati toate campurile obligatorii!', variant: 'danger' })
          throw new Error(invalidFormMessage)
        }
        this.showOverlay = true
        this.overlayMessage = 'Va rugam asteptati, verificam din nou pretul si disponibilitatea produsului selectat...'

        const pax = [...this.pax.map(room => room.map(p => ({
          title: p.title,
          fname: p.fname.toUpperCase(),
          lname: p.lname.toUpperCase(),
          age: p.age,
          bdate: p.bdate,
          tel: this.client.tel ? this.client.tel : ''
        })))]

        let bookParams = {}

        // run new search
        const newParams = model.params
        newParams.hotels = [this.result.id]
        model.params = newParams
        const data = await search(newParams)
        // re-populate model
        model.results = data
        model.sort({ sortMethod: model.sortMethod })

        let newResult = null
        let newCategory = null
        let newMeal = null

        model.results.forEach(result => {
          if (result.id === this.result.id) {
            newResult = result
            result.categories.forEach(category => {
              if (this.category.name === category.name &&
                category.hotelIsAvailable === this.category.hotelIsAvailable &&
                category.hotelIsBlackedOut === this.category.hotelIsBlackedOut &&
                category.isBookable === this.category.isBookable) {
                category.meals.forEach(meal => {
                  const p1 = meal.price + meal.tax
                  const p2 = this.meal.price + this.meal.tax
                  if (meal.code === this.meal.code &&
                  meal.label === this.meal.label &&
                  p1 === p2) {
                    newMeal = meal
                    newCategory = category
                  }
                })
              }
            })
          }
        })

        if (!newResult) throw new Error('Could not find hotel')
        if (!newCategory) throw new Error('Could not find category with similar availability')
        if (!newMeal) throw new Error('Could not find result with similar price')

        // now ok to create booking
        bookParams = {
          source: newResult.source,
          category: newCategory.id,
          meal: newMeal.id,
          notes: this.notes,
          telephone: this.client.tel,
          pax: pax
        }

        if (isOption) bookParams.status = 'option'
        const res = await book(bookParams)
        model.results = []
        this.$emit('book', res[0])
      } catch (err) {
        if (err.message !== invalidFormMessage) {
          this.errorMessage = err.message
          this.showErrorOverlay = true
        }
      } finally { this.showOverlay = false }
    },
    onExtraToggle (extraIndex) {
      const index = this.selectedExtras.indexOf(extraIndex)
      if (index >= 0) this.selectedExtras.splice(index, 1)
      else this.selectedExtras.push(extraIndex)
    },
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      if (no === null || no === undefined) return null
      return Math.ceil(no) + this.params.currency
    }
  }
}
</script>
